import { render, staticRenderFns } from "./researchCenterBasicInformation.vue?vue&type=template&id=2f87312e&"
import script from "./researchCenterBasicInformation.vue?vue&type=script&lang=ts&"
export * from "./researchCenterBasicInformation.vue?vue&type=script&lang=ts&"
import style0 from "./researchCenterBasicInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports